import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@reach/router';
import { I18N } from 'commons';

const ItemTitle = ({ id, expired, title }) => (
  <h2>
    <Link
      to={id}
      eb-test="ee_weatherAlertList_link_itemTitle"
      {...(expired ? { 'aria-describedby': `${id}weatherExpired` } : {})}
    >
      {title}
    </Link>
    {expired && (
      <small
        className="text-danger ml-2"
        eb-test="ee_weatherAlertList_text_expired"
        id={`${id}weatherExpired`}
      >
        <I18N>weather.title.expired</I18N>
      </small>
    )}
  </h2>
);

ItemTitle.propTypes = {
  expired: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default ItemTitle;
